import { Box } from "@mui/material";
import Button from "../Buttons/Button";
import { RectangleEllipsis } from "lucide-react";

/**
 * Notifications button component with active processing indicator
 * @param {Object} props
 * @param {Function} props.onClick - Click handler
 * @param {boolean} props.hasActiveProcessing - Whether there are active processing alerts
 * @param {boolean} props.disabled - Whether the button is disabled
 * @param {Object} props.sx - Additional sx styles
 */
export const NotificationsButton = ({
  onClick,
  hasActiveProcessing,
  disabled = false,
  sx = {},
  ...props
}) => {
  return (
    <Button
      color="secondary"
      onClick={onClick}
      disabled={disabled}
      sx={{
        textTransform: "none",
        height: 42,
        maxHeight: 42,
        minWidth: "max-content",
        px: "10px !important",
        mr: 0.5,
        border: "none",
        boxShadow: "none",
        backgroundColor: "transparent !important",
        "&.MuiButtonBase-root.MuiButton-root:hover": {
          backgroundColor: "transparent !important",
          border: "none !important",
          boxShadow: "none !important",
          color: "inherit !important",
        },
        ...sx,
      }}
      {...props}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {hasActiveProcessing && !disabled && (
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "#4ade80",
              boxShadow: "0 0 12px 2px rgba(74, 222, 128, 0.5)",
              animation: "pulse 1.5s ease-in-out infinite",
              "@keyframes pulse": {
                "0%": { transform: "scale(1)", opacity: 1 },
                "50%": { transform: "scale(1.02)", opacity: 0.8 },
                "100%": { transform: "scale(1)", opacity: 1 },
              },
            }}
          />
        )}
        <RectangleEllipsis size={20} />
      </Box>
    </Button>
  );
};

export default NotificationsButton;
